import { BUTTON_SIZE, BUTTON_TYPE, DSButton, DSInput, DSRadio } from '@repo/design-system/index'
import { useState } from 'react'
import { useEventTracking } from '../../../../../helpers/gtmHelper'
import { useSubmitJobs } from '../../../../../modules/apis/student/lesson'
import { n_ai_analysis, n_common } from '../../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import { PAGE_TYPE } from './JobInputModal'

const JobType = ({ options, pageNum, setPageNum, jobInfo, setJobInfo }) => {
  const { t } = useTranslation()
  const [jobType, setJobType] = useState(options.job_type.find((jobType) => jobType.id == jobInfo?.jobType))
  const [etcJobType, setEtcJobType] = useState('')
  const [loading, setLoading] = useState(false)
  const { mutate } = useSubmitJobs()
  const { sendClickEvent } = useEventTracking()

  const handleNext = () => {
    setLoading(true)
    sendClickEvent({ button_name: 'ai_analysis_job_segment_require_info_poup_next', location_detail: '2' })
    setJobInfo({
      ...jobInfo,
      jobType: jobType.id,
    })
    mutate(
      {
        category: PAGE_TYPE.TYPE,
        selection: jobType.id,
        other: etcJobType,
      },
      {
        onSuccess: () => {
          setPageNum(pageNum + 1)
        },
      }
    )
  }

  const isEtc = () => {
    return jobType?.id === 11
  }

  const isDisabled = () => {
    if (!jobType) return true
    if (isEtc() && !etcJobType) return true

    return false
  }

  return (
    <div className="flex h-full flex-col">
      <div className="h-full min-h-[240px] overflow-y-scroll sm:min-h-[382px]">
        <DSRadio controlSelected={[jobType, setJobType]} containerClassName="flex flex-col space-y-[8px]">
          {options.job_type.map((radioItem, idx) => {
            return (
              <DSRadio.Item key={`radio-group1-${idx}`} value={radioItem}>
                {radioItem.title}
              </DSRadio.Item>
            )
          })}
        </DSRadio>
        {isEtc() && (
          <div className="mt-[12px] pl-[24px]">
            <DSInput
              type="text"
              placeholder={t(n_ai_analysis.info_popup_company_placeholder)}
              value={etcJobType}
              name={'name_input'}
              setValue={setEtcJobType}
              size="sm"
            />
          </div>
        )}
      </div>
      <div className="ml-auto flex w-full flex-row items-end justify-end gap-x-[8px] pb-[18px] pt-[12px] sm:w-[232px] sm:pb-0">
        <DSButton
          type={BUTTON_TYPE.OUTLINE}
          size={BUTTON_SIZE.MD}
          onClick={() => {
            sendClickEvent({ button_name: 'ai_analysis_job_segment_require_info_poup_previous', location_detail: '2' })
            setPageNum(pageNum - 1)
          }}
        >
          <DSButton.Label>{t(n_common.btn_back)}</DSButton.Label>
        </DSButton>
        <DSButton
          isLoading={loading}
          disabled={isDisabled()}
          type={BUTTON_TYPE.SOLID}
          size={BUTTON_SIZE.MD}
          onClick={handleNext}
        >
          <DSButton.Label>{t(n_common.btn_next)}</DSButton.Label>
        </DSButton>
      </div>
    </div>
  )
}

export default JobType
